function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.164 3.48443C10.2035 2.72741 8.81968 2.72741 7.85917 3.48443L3.20165 7.15525C2.79998 7.47183 2.56717 7.9445 2.56717 8.4434V14.4372C2.56717 15.3577 3.34445 16.1039 4.30328 16.1039H14.7199C15.6788 16.1039 16.4561 15.3577 16.4561 14.4372V8.44341C16.4561 7.9445 16.2232 7.47183 15.8216 7.15525L11.164 3.48443ZM6.75755 2.19628C8.35839 0.934573 10.6648 0.934575 12.2657 2.19628L16.9232 5.86709C17.7265 6.50025 18.1922 7.44559 18.1922 8.44341V14.4372C18.1922 16.2782 16.6376 17.7705 14.7199 17.7705H4.30328C2.38562 17.7705 0.831055 16.2782 0.831055 14.4372V8.4434C0.831055 7.44559 1.29669 6.50025 2.10003 5.86709L6.75755 2.19628Z",
    fill: "#5554FB",
    style: {
      fill: "#5554FB",
      fill: "color(display-p3 0.3333 0.3294 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1641 10V8.33333H15.8307V10H17.4974H19.1641ZM17.4974 10H15.8307C15.8307 10.857 15.8514 11.5411 15.863 12.0706C15.8752 12.6219 15.8758 12.9628 15.8525 13.2317C15.8204 13.6036 15.7602 13.8373 15.3252 14.4241L16.6641 15.4167L18.0029 16.4092C18.7207 15.4411 19.0772 14.6331 19.1735 13.5188C19.2145 13.0445 19.2073 12.5311 19.1956 11.9973C19.1833 11.4416 19.1641 10.8096 19.1641 10H17.4974ZM16.6641 15.4167L15.3252 14.4241C15.1855 14.6125 14.8662 14.8593 13.7327 14.9654C12.5732 15.0739 11.1677 15 9.16406 15V16.6667V18.3333C10.9104 18.3333 12.6786 18.4119 14.0433 18.2842C15.4341 18.154 16.9899 17.7758 18.0029 16.4092L16.6641 15.4167Z",
    fill: "#EEEEFF",
    style: {
      fill: "#EEEEFF",
      fill: "color(display-p3 0.9333 0.9333 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91406 16.9376H11.2474",
    stroke: "#5554FB",
    style: {
      stroke: "#5554FB",
      stroke: "color(display-p3 0.3333 0.3294 0.9843)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4392 10C16.4392 10.4909 16.8372 10.8889 17.3281 10.8889C17.819 10.8889 18.217 10.4909 18.217 10H17.3281H16.4392ZM17.3281 10H18.217V8.33333H17.3281H16.4392V10H17.3281Z",
    fill: "#5554FB",
    style: {
      fill: "#5554FB",
      fill: "color(display-p3 0.3333 0.3294 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9722 13.3345C15.0134 13.3345 14.2361 14.0807 14.2361 15.0012C14.2361 15.9217 15.0134 16.6678 15.9722 16.6678C16.931 16.6678 17.7083 15.9217 17.7083 15.0012C17.7083 14.0807 16.931 13.3345 15.9722 13.3345ZM12.5 15.0012C12.5 13.1602 14.0546 11.6678 15.9722 11.6678C17.8899 11.6678 19.4444 13.1602 19.4444 15.0012C19.4444 16.8421 17.8899 18.3345 15.9722 18.3345C14.0546 18.3345 12.5 16.8421 12.5 15.0012Z",
    fill: "#5554FB",
    style: {
      fill: "#5554FB",
      fill: "color(display-p3 0.3333 0.3294 0.9843)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.6245405b9e123b331fd03b3bd0daa35f.svg";
export { ForwardRef as ReactComponent };